export const ProductDetailsAccordion = {
  mounted() {
    window.addEventListener('vulcan:focus_accordion', () => {
      this.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
};
